import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Footer from "../components/Footer";
import { toast } from "react-toastify";
import "./Login.css";


// Import your video
import bgVideo from "../assets/bgVideo.mp4";
import leftLogo from "../assets/ciallogo.png";
import rightLogo from "../assets/krrlogo.jpg";

function Login() {
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        username: "",
        password: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleLogin = async (e) => {

        e.preventDefault();

        try {

            const response = await fetch(`${API_URL}/portal/login`, {

                method: "POST",

                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(formData),

            });

            const data = await response.json();

            if (data.status) {

                toast.success(data.message);

                // Save session: token is what authFetch attaches to
                // every subsequent API call; user (incl. role) drives
                // what the sidebar/pages show.
                localStorage.setItem("token", data.access_token);

                localStorage.setItem(
                    "user",
                    JSON.stringify(data.user)
                );

                localStorage.setItem(
                    "permissions",
                    JSON.stringify(data.permissions || {})
                );

                setTimeout(() => {

                    navigate("/dashboard");

                }, 1000);

            } else {

                toast.error(data.message);

            }

        } catch (error) {

            console.error(error);

            toast.error("Unable to connect to server.");

        }

    };

    return (
        <div className="login-page">

            {/* Background Video */}
            <video
                className="background-video"
                autoPlay
                muted
                loop
                playsInline
            >
                <source src={bgVideo} type="video/mp4" />
            </video>

            <div className="video-overlay"></div>

            {/* Top Logos */}
            <div className="top-header">

                <img
                    src={leftLogo}
                    alt="CIAL Logo"
                    className="header-logo left-logo"
                />

                <img
                    src={rightLogo}
                    alt="KRR Logo"
                    className="header-logo right-logo"
                />

            </div>

            {/* Login */}
            <div className="login-container">

                <div className="login-card">

                   {/*  <h2>Welcome Back</h2> */}

                    <form onSubmit={handleLogin}>

                        <div className="form-group">
                            <label>Username</label>

                            <input
                                type="text"
                                name="username"
                                placeholder="Enter Username"
                                value={formData.username}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label>Password</label>

                            <input
                                type="password"
                                name="password"
                                placeholder="Enter Password"
                                value={formData.password}
                                onChange={handleChange}
                            />
                        </div>

                        <button className="login-btn">
                            Login
                        </button>

                        <Link to="/forgot-password" className="forgot-password-link">
                            Forgot Password?
                        </Link>

                       {/*  <Link to="/verify-mobile" className="forgot-password-link">
                            Verify Mobile Number
                        </Link> */}

                    </form>

                </div>

            </div>

            <Footer transparent />

        </div>
    );
}

export default Login;